import { MainContainer } from "../../component/container";
import Spon from '../../assets/image/sponsor.jpg'
import BouncingIcon from "../../component/BouncingIcon";
import { useNavigate } from 'react-router';
import Sp1 from '../../assets/image/sp1.gif'
import Sp2 from '../../assets/image/sp2.gif'
import Sp3 from '../../assets/image/sp3.gif'
import SB2 from '../../assets/image/SIDEBAR2.jpg'
import ICO from '../../assets/ico/charity.png'
import { Element, Link } from 'react-scroll';

export default function Sponsor() {
    const navigate = useNavigate();

    return (
        <MainContainer>
            <div id='content' className="">
                <img src={Spon} alt="Spon" className='w-screen h-screen object-cover opacity-70' />

                <div className="w-full absolute top-1/2 left-0 transform -translate-y-1/2 2xl:px-80 xl:px-52 px-10">
                    <div className="bg-[#87ceeb] bg-opacity-70 p-4 rounded-full">
                        <h1 className="text-lg sm:text-4xl font-bold text-white text-center">Sponsor a child.</h1>
                    </div>
                </div>


                <Link to="Scroll" smooth={true} duration={500}>
                    <BouncingIcon />
                </Link>
            </div>
            <Element name="Scroll" className="element"><div className='min-h-[2px]'></div></Element>

            <div className="2xl:px-80 xl:px-52 px-10 mt-24 flex flex-col gap-20">
                <div className="flex lg:flex-row flex-col gap-5 justify-between items-center">
                    <img src={Sp1} alt="Sp1" className='max-w-[600px] w-full' />
                    <div>
                        Above are street children the ACRFI assesses in a daily basis in the Democratic Republique of the Congo, by transforming their lives as we place them, one by one, in a dedicated family to care for. We provide them with the basic needs, security, and an education to break the cycle of juvenile delinquency, pauverty and death due to tropical diseases and HIV/ AIDS. Please <span className="text-blue-400 hover:underline" onClick={() => { navigate('/Contact') }}>contact us</span> and be proud to save the lives of more orphans in the Congo (DRC)
                    </div>
                </div>
                <div className="flex lg:flex-row flex-col gap-5 justify-between items-center">
                    <img src={Sp2} alt="Sp2" className='max-w-[600px] w-full' />
                    <div>
                        <span>YOU CAN SPONSOR A CHILD THROUGH OUR FOUNDATION:</span>
                        <p>
                            BY BECOMING A PARTNER TO THE ACRFI FOR $25.00 U$D OR MORE A MONTH(that's less than 85 cents U$D a day for the care of thousands of Orphans still wondering in the streets of Congo DRC and street Kids in US today!!)
                        </p>
                        <span>
                            BECOME A PARTNER TODAY
                        </span>
                        <p>
                            OR BY GIVING A ONE TIME DONATION OF ANY AMOUNT TO THE WORK OF GOD TODAY; AND REMIMBER..A DONATION IS NEVER TOO SMALL OR TOO BIG!
                        </p>
                    </div>
                </div>

                <div>
                    <span>
                        Your donations help us respond to the very needs of these orphans, as we:
                    </span>
                    <div className="flex flex-col">
                        <span>1. Build them a shelter</span>
                        <span>2. Provide them with clothes and shoes</span>
                        <span>3. Ensure they are fed and prevented from diseases</span>
                        <span>4. Provide them with an education, assist them rebuild a strong spirit through rehabilitation, and give them hope for tomorrow</span>
                        <span>5. Prepare them to face their future with confidence in God</span>
                    </div>
                </div>

                <div className="flex sm:flex-row flex-col gap-5 justify-between items-center">
                    <div>
                        Our mission is to ensure that children of any neighborhood, especially orphans and less fortunate abandoned children are given a chance to become a positive, active and vital part of our society.  With this in mind, our vision is to contribute to the abolition of worldwide juvenile delinquency as well as different crimes that young people are involved in today.
                    </div>
                    <img src={SB2} alt="Sb2" className='max-w-[600px]' />
                </div>

                <div className="flex flex-col justify-center items-center">
                    <span className="italic">"By securing our youth's safety and education, we will secure the future of this world we are living in."</span>

                    <span className="font-bold">(The ACRFI Founder)</span>
                </div>

                <div>
                    <div className="flex lg:flex-row flex-col items-center justify-center">
                        <img src={Sp3} alt="sp3" className="mr-4 w-full" style={{ maxHeight: '600px' }} />
                        <div>
                            <p>The children in school uniform ( Right hand side) are the group of our pionneer orphans we take complete care of, for the last 6 years.

                                They are orphans of both parents living either with some relatives or good samaritan families. We have lost some children along the way, dropping school and running away from those families for multiple reasons; but with your support, we manage to give those that remain, a hope for their future. "WE COULD NOT HAVE DONE IT WITHOUT THE SUPPORT OF OUR PARTNERS!"</p>
                        </div>
                    </div>
                    <div className="mt-1">How about the thousands that are still wondering in the streets of Congo, DRC? Would you join your effort to ours and save their lives?
                        Every year, the Founder, Co-founder or other members of our foundation, the ACRFI, travel to Congo and bring the collected supports, either monetary or goods to the orphans of the ACRFI-CONGO, and assess their progress in school, as well as their well-being.
                    </div>
                </div>

                <div className="flex flex-col items-center justify-center">
                    <div className="flex items-center text-blue-400 gap-3">Donate today and make a difference in their lives today! by clicking to this icon <img src={ICO} alt={'ICO'} sizes={40} className="cursor-pointer" /> </div>
                    <div>Or go to: <span className="text-blue-400 hover:underline cursor-pointer" onClick={() => { navigate('/Donate') }}>donate today</span> and choose your best way to give to the work of God!</div>
                </div>
            </div>
        </MainContainer>
    )
}